export const TIMEOUT_ERROR = 'timeout-error';

/**
 * @param delay
 * @returns {Promise<unknown>}
 */
export const timeoutHandler = (delay = 10000) =>
  new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error(TIMEOUT_ERROR));
    }, delay);
  });

/**
 * @param query
 * @returns {number|number}
 */
export const getStartQueryPage = (query) => (query?.page ? query?.page - 1 : 0);
